import { createSlice } from '@reduxjs/toolkit';

import { SelectRemoveState } from '../../models/SelectRemove';

export const initialState: SelectRemoveState = {
  selectedShipments: [],
  editMode: false,
};

export const selectRemoveSlice = createSlice({
  name: 'selectRemove',
  initialState,
  reducers: {
    selectShipment: (state, action: { payload: string }) => {
      const { selectedShipments } = state;

      // When list is empty
      if (!selectedShipments.length) return;

      const { payload: articleId } = action; // Payload is an articleId string
      const selectedShipment = selectedShipments.find((shipment) => shipment.trackingId === articleId);
      if (selectedShipment) selectedShipment.checked = !selectedShipment.checked;
    },
    toggleEditMode: (state, action) => {
      const { editMode, shipments } = action.payload;
      state.editMode = editMode;
      state.selectedShipments = editMode ? shipments : [];
    },
    selectAll: (state, action) => {
      state.selectedShipments.forEach((shipment) => {
        shipment.checked = action.payload;
      });
    },
  },
});

export const { selectShipment, selectAll, toggleEditMode } = selectRemoveSlice.actions;
